module.exports = __webpack_public_path__ + "img/search-icon1.3fbb5bd6.svg";